/*=========================================================================================
  File Name: moduleTreatmentsState.js
  Description: Treatments Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  treatments: [],
  side_effects: [],
  laboratory_monitorings: [],
}
